import { createRootRoute, Outlet } from '@tanstack/react-router'
import { Provider as JotaiProvider } from 'jotai'
import { ThemeProvider } from '../contexts/ThemeContext'
import { Layout } from '../components'
import '../styles/global.css'
import { ExternalLibs } from '../components/ExternalLibs/ExternalLibs'
import { ErrorBoundary } from '@/components/ErrorBoundary/ErrorBoundary'
import { NotFoundPage } from '@/components/infoPages/NotFoundPage'
import { useVersionCheck } from '@/hooks/useVersionCheck'

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: ErrorBoundary,
  notFoundComponent: NotFoundPage,
})

/** Runs useVersionCheck inside the Jotai provider (required for useSetAtom). */
function VersionWatcher() {
  useVersionCheck()
  return null
}

function RootComponent() {
  return (
    <JotaiProvider>
      <VersionWatcher />
      <ExternalLibs />
      <ThemeProvider>
        <Layout>
          <Outlet />
        </Layout>
      </ThemeProvider>
    </JotaiProvider>
  )
}